module.exports = __webpack_public_path__ + "img/tmx_store_samsung_s_drive_budaors_1024.1c653b15.jpg";